import { render } from "./DashedButton.vue?vue&type=template&id=63c5dbd7&scoped=true"
import script from "./DashedButton.vue?vue&type=script&lang=ts"
export * from "./DashedButton.vue?vue&type=script&lang=ts"

import "./DashedButton.vue?vue&type=style&index=0&id=63c5dbd7&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-63c5dbd7"

export default script